export default "__VITE_ASSET__CuKi1gkz__"